import React, { useState, useEffect } from "react";
import "./Nav.css";

function Nav() {
  const [show, handleShow] = new useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        handleShow(true);
      } else {
        handleShow(false);
      }
    });
    return () => {
      window.removeEventListener("scroll");
    };
  }, []);

  return (
    <div className={`nav ${show && "nav__black"}`}>
      <img
        src="https://www.freepnglogos.com/uploads/netflix-logo-0.png"
        alt="logo"
        className="nav__logo"
      />

      <img
        src="https://pbs.twimg.com/media/CW2i0pJW4AEYFI3.png"
        alt="avatar"
        className="nav__avatar"
      />
    </div>
  );
}

export default Nav;
